/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1CostcentersQueryResponse } from '../../types/GetV1Costcenters.ts'

export const getV1CostcentersQueryKey = () => [{ url: '/v1/CostCenters' }] as const

export type GetV1CostcentersQueryKey = ReturnType<typeof getV1CostcentersQueryKey>

/**
 * {@link /v1/CostCenters}
 */
export async function getV1Costcenters(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<GetV1CostcentersQueryResponse, ResponseErrorConfig<Error>, unknown>({
        method: 'GET',
        url: `/v1/CostCenters`,
        ...requestConfig,
    })
    return res
}

export function getV1CostcentersQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1CostcentersQueryKey()
    return queryOptions<
        ResponseConfig<GetV1CostcentersQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1CostcentersQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Costcenters(config)
        },
    })
}

/**
 * {@link /v1/CostCenters}
 */
export function useGetV1Costcenters<
    TData = ResponseConfig<GetV1CostcentersQueryResponse>,
    TQueryData = ResponseConfig<GetV1CostcentersQueryResponse>,
    TQueryKey extends QueryKey = GetV1CostcentersQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1CostcentersQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1CostcentersQueryKey()

    const query = useQuery(
        {
            ...getV1CostcentersQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
